import createIcon from '../../createIcon';

/**
 * @component @name SignalWifi0Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgNS41QzE1LjMzIDUuNSAxOC40OSA2LjU4IDIxLjA4IDguNTdMMTIgMTcuNjdMMi45MiA4LjU3QzUuNTEgNi41OCA4LjY3IDUuNSAxMiA1LjVaTTEyIDMuNUM3LjMxIDMuNSAzLjA3IDUuNCAwIDguNDhMMTIgMjAuNUwyNCA4LjQ4QzIwLjkzIDUuNCAxNi42OSAzLjUgMTIgMy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalWifi0Bar = createIcon('SignalWifi0Bar', [
  [
    'path',
    {
      d: 'M12 5.5C15.33 5.5 18.49 6.58 21.08 8.57L12 17.67L2.92 8.57C5.51 6.58 8.67 5.5 12 5.5ZM12 3.5C7.31 3.5 3.07 5.4 0 8.48L12 20.5L24 8.48C20.93 5.4 16.69 3.5 12 3.5Z',
      key: '7i3eux',
    },
  ],
]);

export default SignalWifi0Bar;
